export default "__VITE_ASSET__3dc56d1e__"